/**
 * Native HTML5 video renderer
 */

import { Box } from '@mantine/core';

interface VideoRendererProps {
  src: string;
  mimeType: string;
}

export function VideoRenderer({ src, mimeType }: VideoRendererProps) {
  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <video
        controls
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          borderRadius: 8,
        }}
      >
        <source src={src} type={mimeType} />
        Your browser does not support video playback.
      </video>
    </Box>
  );
}
